
import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/common/banner.vue';
import FootBox from '@/components/common/footBox.vue';
@Component({
    components: {
        Banner,
        FootBox,
    },
})
export default class Home extends Vue {
    /*    beforeDestroy() {
        let banner = this.$refs.banner as Banner;
        banner.clearTimer();
    } */
}
